import { useEffect, useState } from "react";
import { InternalDisplayConfig } from "shared/src/types/ArticleCardProps";
import { PriceAndPromotionInfo } from "shared/src/types/PriceAndPromotionInfo";
import { getPriceInfoToDisplay } from "shared/src/utils/PriceDisplayFramework";

export function usePriceData(
    priceAndPromotionInfo: PriceAndPromotionInfo | null,
    internalDisplayConfig: InternalDisplayConfig,
    isWeightedArticleRaw: "WEIGHT" | "NON_WEIGHT" | undefined
) {
    const [priceData, setPriceDisplayData] = useState(
        getPriceInfoToDisplay(priceAndPromotionInfo, internalDisplayConfig)
    );
    const [isWeightArticle, setIsWeightedArticle] = useState(isWeightedArticleRaw === "WEIGHT");

    useEffect(() => {
        setPriceDisplayData(getPriceInfoToDisplay(priceAndPromotionInfo, internalDisplayConfig));
    }, [priceAndPromotionInfo, internalDisplayConfig]);

    useEffect(() => {
        setIsWeightedArticle(isWeightedArticleRaw === "WEIGHT");
    }, [isWeightedArticleRaw]);

    return {
        priceData,
        isWeightArticle
    };
}
